<template>
  <div>
    <!-- 标题 -->
    <div class="redis-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.cacheClusterId }}</BreadcrumbItem>
        <BreadcrumbItem to="/elasticache/redisMonitor">Redis</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="redis-top">
      <Row :gutter="16">
        <Col span="6" v-show="isAWS">
          <Select v-model="timeType" @on-change="changeTimeType(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-if="isALY">
          <Select v-model="timeType" @on-change="changeTimeTypeALY(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-if="isGCP">
          <Select v-model="timeType" @on-change="changeTimeTypeGCP(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6">
          <Select v-model="cycle" @on-change="changeCycle()">
            <Option
              v-for="item in cycleList"
              :value="item.value"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <Col span="6" v-if="isGCP">
          <Select v-model="name" @on-change="changeNameGCP(name)">
            <Option v-for="item in nameList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="6"
        v-for="(item, index) in this.$route.query.accountTypeName == 'AWS'
          ? awsList
          : this.$route.query.accountTypeName == 'Aliyun'
          ? alyList
          : this.$route.query.accountTypeName == 'Azure'
          ? azureList
          : this.$route.query.accountTypeName == 'GCP'
          ? gcpList
          : gcpList"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
export default {
  name: "Redis",
  data() {
    return {
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      //AWS折线图
      awsList: [
        {
          id: "cpuUtilization",
          title: this.$t("alarms.instance.line.CPUUtilizationPercent"),
        },
        {
          id: "memoryUtilization",
          title: this.$t("alarms.instance.line.MemoryUsagePercentage"),
        },
        {
          id: "currConnection",
          title: this.$t("alarms.redis.currConnectionAmount"),
        },
        {
          id: "bytesUsedForCache",
          title: this.$t("alarms.redis.bytesUsedForCacheByte"),
        },
        {
          id: "networkInputAndOutput",
          title: this.$t("alarms.instance.line.NetworkInputAndOutputBytes"),
        },
      ],
      // 阿里云折线图
      alyList: [
        {
          id: "standardCpuUsage",
          title: this.$t("alarms.instance.line.StandardCpuUsage"),
        },
        {
          id: "standardMemoryUsage",
          title: this.$t("alarms.instance.line.StandardMemoryUsage"),
        },
        {
          id: "standardConnectionUsage",
          title: this.$t("alarms.instance.line.StandardConnectionUsage"),
        },
        {
          id: "standardQPSUsage",
          title: this.$t("alarms.instance.line.StandardQPSUsage"),
        },
        {
          id: "standardIntranetRatio",
          title: this.$t("alarms.instance.line.StandardIntranetRatio"),
        },
      ],
      cycle: 300,
      cycleList: [
        {
          name: this.$t("alarms.common.fiveMinutes"),
          value: 5 * 60,
        },
        {
          name: this.$t("alarms.common.fifteenMinutes"),
          value: 15 * 60,
        },
        {
          name: this.$t("alarms.common.oneHour"),
          value: 1 * 60 * 60,
        },
        {
          name: this.$t("alarms.common.sixHour"),
          value: 6 * 60 * 60,
        },
        {
          name: this.$t("alarms.common.oneDay"),
          value: 24 * 60 * 60,
        },
      ],
      //azure折线图
      azureList: [],
      //gcp折线图
      gcpList: [
        {
          id: "cacheHitRatio",
          title: this.$t("alarms.instance.line.CacheHitRatio"),
        },
        {
          id: "redisCpuUtilization",
          title: this.$t("alarms.instance.line.RedisCpuUtilization"),
        },
        {
          id: "keyspaceMisses",
          title: this.$t("alarms.instance.line.KeyspaceMisses"),
        },
        {
          id: "systemMemoryUsageRatio",
          title: this.$t("alarms.instance.line.SystemMemoryUsageRatio"),
        },
        {
          id: "usageRatio",
          title: this.$t("alarms.instance.line.UsageRatio"),
        },
        {
          id: "connectionsTotal",
          title: this.$t("alarms.instance.line.ConnectionsTotal"),
        },
      ],
      isAWS: false,
      isALY: false,
      isGCP: false,
      timeType: 0,
      redisGroupBy: "",
      timeList: [],

      nameList: [],
      id: "",
      accountId: "",
      accountTypeName: "",
      accountName: "",
      region: "",
      name: "",
      cacheClusterId: "",
      instanceId: "",
      // echarts实例
      chartCpuUtilization: "",
      chartMemoryUtilization: "",
      chartCurrConnection: "",
      chartBytesUsedForCache: "",
      chartNetworkInputAndOutput: "",
      chartStandardCpuUsage: "",
      chartStandardMemoryUsage: "",
      chartStandardConnectionUsage: "",
      chartStandardQPSUsage: "",
      chartCacheHitRatio: "",
      chartRedisCpuUtilization: "",
      chartKeyspaceMisses: "",
      chartConnectionsTotal: "",
      chartSystemMemoryUsageRatio: "",
      chartUsageRatio: "",
      chartStandardIntranetRatio: "",
      cpuUtilizationOption: {},
      memoryUtilizationOption: {},
      currConnectionOption: {},
      bytesUsedForCacheOption: {},
      networkInputAndOutputOption: {},
      standardCpuUsageOption: {},
      standardMemoryUsageOption: {},
      standardConnectionUsageOption: {},
      standardQPSUsageOption: {},
      cacheHitRatioOption: {},
      redisCpuUtilizationOption: {},
      keyspaceMissesOption: {},
      connectionsTotalOption: {},
      systemMemoryUsageRatioOption: {},
      usageRatioOption: {},
      standardIntranetRatioOption: {},

      //AWS数组
      cpuUtilizationList: [],
      memoryUtilizationList: [],
      clusterYellowStatusList: [],
      currConnectionList: [],
      bytesUsedForCacheList: [],
      networkBytesOutList: [],
      networkBytesInList: [],
      standardCpuUsageList: [],
      standardMemoryUsageList: [],
      standardConnectionUsageList: [],
      standardQPSUsageList: [],
      cacheHitRatioList: [],
      redisCpuUtilizationList: [],
      keyspaceMissesList: [],
      connectionsTotalList: [],
      systemMemoryUsageRatioList: [],
      usageRatioList: [],
      standardIntranetInRatioList: [],
      standardIntranetOutRatioList: [],
      xaxisData: [],
    };
  },
  mounted: function () {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartCpuUtilization.resize();
        self.chartMemoryUtilization.resize();
        self.chartCurrConnection.resize();
        self.chartBytesUsedForCache.resize();
        self.chartNetworkInputAndOutput.resize();
      });
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      //this.isAWS = false;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartStandardCpuUsage.resize();
        self.chartStandardMemoryUsage.resize();
        self.chartStandardConnectionUsage.resize();
        self.chartStandardQPSUsage.resize();
        self.chartStandardIntranetRatio.resize();
      });
    } else if (this.$route.query.accountTypeName == "GCP") {
      this.isGCP = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartCacheHitRatio.resize();
        self.chartRedisCpuUtilization.resize();
        self.chartKeyspaceMisses.resize();
        self.chartSystemMemoryUsageRatio.resize();
        self.chartUsageRatio.resize();
        self.chartConnectionsTotal.resize();
      });
    }
  },
  created() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.checkMonitorModuleIndex();
    } else if (this.$route.query.accountTypeName == "Azure") {
      this.isAzure = true;
      this.checkAzureCloudVMDiskStatistics();
    } else if (this.$route.query.accountTypeName == "Aliyun") {
      this.isALY = true;
      this.checkAliRedisStatistics();
    } else if (this.$route.query.accountTypeName == "GCP") {
      this.isGCP = true;
      this.redisGroupByBox();
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function (item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          if (item.id == "cpuUtilization") {
            var optionFll = this.cpuUtilizationOption;
          } else if (item.id == "memoryUtilization") {
            var optionFll = this.memoryUtilizationOption;
          } else if (item.id == "currConnection") {
            var optionFll = this.currConnectionOption;
          } else if (item.id == "bytesUsedForCache") {
            var optionFll = this.bytesUsedForCacheOption;
          } else if (item.id == "networkInputAndOutput") {
            var optionFll = this.networkInputAndOutputOption;
          } else if (item.id == "standardCpuUsage") {
            var optionFll = this.standardCpuUsageOption;
          } else if (item.id == "standardMemoryUsage") {
            var optionFll = this.standardMemoryUsageOption;
          } else if (item.id == "standardConnectionUsage") {
            var optionFll = this.standardConnectionUsageOption;
          } else if (item.id == "standardQPSUsage") {
            var optionFll = this.standardQPSUsageOption;
          } else if (item.id == "standardIntranetRatio") {
            var optionFll = this.standardIntranetRatioOption;
          } else if (item.id == "cacheHitRatio") {
            var optionFll = this.cacheHitRatioOption;
          } else if (item.id == "redisCpuUtilization") {
            var optionFll = this.redisCpuUtilizationOption;
          } else if (item.id == "keyspaceMisses") {
            var optionFll = this.keyspaceMissesOption;
          } else if (item.id == "systemMemoryUsageRatio") {
            var optionFll = this.systemMemoryUsageRatioOption;
          } else if (item.id == "usageRatio") {
            var optionFll = this.usageRatioOption;
          } else if (item.id == "connectionsTotal") {
            var optionFll = this.connectionsTotalOption;
          }

          fullChart.setOption(optionFll);
          window.addEventListener("resize", function () {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function () {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then((res) => {
          this.timeList = res.data;
        });
    },

    // Aws折线图
    checkAWSEsStatistics: function () {
      this.$api.cloudWatch
        .checkAWSElastiCacheStatistics({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 5,
          region: this.$route.query.region,
          cacheClusterId: this.$route.query.cacheClusterId,
        })
        .then((res) => {
          this.xaxisData = res.data.xaxisData;
          this.cpuUtilizationList = res.data.cpuUtilization;
          this.memoryUtilizationList = res.data.memoryUtilization;
          this.currConnectionList = res.data.currConnection;
          this.bytesUsedForCacheList = res.data.bytesUsedForCache;
          this.networkBytesOutList = res.data.networkBytesOut;
          this.networkBytesInList = res.data.networkBytesIn;
          this.allAws();
        });
    },
    //阿里云折线图
    checkAliRedisStatistics: function () {
      this.$api.cloudWatch
        .checkAliRedisStatistics({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 5,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
        })
        .then((res) => {
          this.diskSpaceUtilizationAliyun = res.data.diskSpaceUtilization;
          this.diskReadIOPSAliyun = res.data.readIOPSUsage;
          this.diskWriteIOPSAliyun = res.data.writeIOPSUsage;
          this.xaxisData = res.data.xaxisData;
          this.standardCpuUsageList = res.data.standardCpuUsage;
          this.standardMemoryUsageList = res.data.standardMemoryUsage;
          this.standardConnectionUsageList = res.data.standardConnectionUsage;
          this.standardQPSUsageList = res.data.standardQPSUsage;
          this.standardIntranetInRatioList = res.data.standardIntranetInRatio;
          this.standardIntranetOutRatioList = res.data.standardIntranetOutRatio;
          this.allALY();
        });
    },
    initRedisData: function (obj) {
      let arr = [];
      if (ojb != null || obj.length != 0) {
        for (let i = 0; i < obj.length; i++) {
          for (const key in obj[i]) {
            if (key == "datapointList") {
              arr.push({
                data: obj["datapointList"],
              });
            }
          }
        }
      }

      return arr;
    },
    //GCP折线图
    checkGcpRedisIndex: function () {
      this.$api.cloudWatch
        .checkGcpRedisIndex({
          accountId: this.$route.query.accountId,
          name: this.$route.query.name,
          timeHorizon: this.timeType,
          monitorModule: 5,
          region: this.$route.query.region,
          redisGroupBy: this.name,
        })
        .then((res) => {
          //Node
          if (res.data.redisGroupBy == 1) {
            this.cacheHitRatioList = this.initRedisData(
              res.data.cacheHitRatioNodeList == null ||
                cacheHitRatioNodeList == undefined
                ? []
                : res.data.cacheHitRatioNodeList
            );
            this.redisCpuUtilizationList = this.initRedisData(
              res.data.redisCpuUtilizationNodeList == null ||
                redisCpuUtilizationNodeList == undefined
                ? []
                : res.data.redisCpuUtilizationNodeList
            );
            this.keyspaceMissesList = this.initRedisData(
              res.data.keyspaceMissesNodeList == null ||
                keyspaceMissesNodeList == undefined
                ? []
                : res.data.keyspaceMissesNodeList
            );
            this.systemMemoryUsageRatioList = this.initRedisData(
              res.data.systemMemoryUsageRatioNodeList == null ||
                systemMemoryUsageRatioNodeList == undefined
                ? []
                : res.data.systemMemoryUsageRatioNodeList
            );
            this.usageRatioList = this.initRedisData(
              res.data.usageRatioNodeList == null ||
                usageRatioNodeList == undefined
                ? []
                : res.data.usageRatioNodeList
            );
            this.connectionsTotal = this.initRedisData(
              res.data.connectionsTotalNodeList == null ||
                connectionsTotalNodeList == undefined
                ? []
                : res.data.connectionsTotalNodeList
            );
            this.xaxisData = res.data.cacheHitRatioNodeList[0].xaxisData;
            this.allGcp();
          }
          //实例
          if (res.data.redisGroupBy == 0) {
            this.cacheHitRatioList = res.data.cacheHitRatio;
            this.redisCpuUtilizationList = res.data.redisCpuUtilization;
            this.keyspaceMissesList = res.data.keyspaceMisses;
            this.systemMemoryUsageRatioList = res.data.systemMemoryUsageRatio;
            this.usageRatioList = res.data.usageRatio;
            this.connectionsTotal = res.data.connectionsTotal;
            this.xaxisData = res.data.xaxisData;
            this.allGcp();
          }
        });
    },
    changeTimeType: function () {
      this.checkAWSEsStatistics();
    },
    changeTimeTypeALY: function () {
      this.checkAliRedisStatistics();
    },
    changeTimeTypeGCP: function () {
      this.checkGcpRedisIndex();
    },
    //分组下拉框
    redisGroupByBox: function () {
      this.$api.cloudWatch.redisGroupByBox().then((res) => {
        this.nameList = res.data;
        this.name = res.data[0].id;
        this.redisGroupBy = res.data.id;
        this.checkGcpRedisIndex();
      });
    },
    //切换分组
    changeNameGCP: function () {
      this.checkGcpRedisIndex();
    },
    // 切换周期
    changeCycle: function () {
      this.checkAWSEsStatistics();
    },
    /******************所有折线图********************************/
    allAws: function () {
      this.cpuUtilizationLine();
      this.memoryUtilizationLine();
      this.currConnectionLine();
      this.bytesUsedForCacheLine();
      this.networkInputAndOutputLine();
    },
    allALY: function () {
      this.standardCpuUsageLine();
      this.standardMemoryUsageLine();
      this.standardConnectionUsageLine();
      this.standardQPSUsageLine();
      this.standardIntranetRatioLine();
    },
    allGcp: function () {
      this.cacheHitRatioLine();
      this.redisCpuUtilizationLine();
      this.keyspaceMissesLine();
      this.systemMemoryUsageRatioLine();
      this.usageRatioLine();
      this.connectionsTotalLine();
    },
    /*************AWS折线图*****************************/
    // CPU利用率 (百分比)
    cpuUtilizationLine: function () {
      this.chartCpuUtilization = this.$echarts.init(
        this.$refs.cpuUtilization[0]
      );
      this.cpuUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // CPU利用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.CPUUtilization")],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.CPUUtilization"),
            type: "line",
            data: this.cpuUtilizationList,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartCpuUtilization.setOption(this.cpuUtilizationOption);
    },
    // 内存使用率 (百分比)
    memoryUtilizationLine: function () {
      this.chartMemoryUtilization = this.$echarts.init(
        this.$refs.memoryUtilization[0]
      );
      this.memoryUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 内存使用率
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.MemoryUsage")],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.MemoryUsage"),
            type: "line",
            data: this.memoryUtilizationList,
            itemStyle: {
              normal: {
                color: "#ceca58",
                lineStyle: {
                  color: "#ceca58",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartMemoryUtilization.setOption(this.memoryUtilizationOption);
    },
    // 当前连接数(数量)
    currConnectionLine: function () {
      this.chartCurrConnection = this.$echarts.init(
        this.$refs.currConnection[0]
      );
      this.currConnectionOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 当前连接数
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.redis.currConnection")],
        },
        series: [
          {
            name: this.$t("alarms.redis.currConnection"),
            type: "line",
            data: this.currConnectionList,
            itemStyle: {
              normal: {
                color: "#93b7e3",
                lineStyle: {
                  color: "#93b7e3",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartCurrConnection.setOption(this.currConnectionOption);
    },
    // 缓存字节数(字节)
    bytesUsedForCacheLine: function () {
      this.chartBytesUsedForCache = this.$echarts.init(
        this.$refs.bytesUsedForCache[0]
      );
      this.bytesUsedForCacheOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 缓存字节数
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.redis.bytesUsedForCache")],
        },
        series: [
          {
            name: this.$t("alarms.redis.bytesUsedForCache"),
            type: "line",
            data: this.bytesUsedForCacheList,
            itemStyle: {
              normal: {
                color: "#f58db2",
                lineStyle: {
                  color: "#f58db2",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartBytesUsedForCache.setOption(this.bytesUsedForCacheOption);
    },
    // 网络输入输出 (字节)
    networkInputAndOutputLine: function () {
      this.chartNetworkInputAndOutput = this.$echarts.init(
        this.$refs.networkInputAndOutput[0]
      );
      this.networkInputAndOutputOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 网络输入 网络输出
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.NetworkInput"),
            this.$t("alarms.instance.line.NetworkOutput"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.NetworkInput"),
            type: "line",
            data: this.networkBytesInList,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
          {
            name: this.$t("alarms.instance.line.NetworkOutput"),
            type: "line",
            data: this.networkBytesOutList,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNetworkInputAndOutput.setOption(
        this.networkInputAndOutputOption
      );
    },
    /*************阿里云折线图*****************************/
    //CPU使用率
    standardCpuUsageLine: function () {
      this.chartStandardCpuUsage = this.$echarts.init(
        this.$refs.standardCpuUsage[0]
      );
      this.standardCpuUsageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.StandardCpuUsage")],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.StandardCpuUsage"),
            type: "line",
            data: this.standardCpuUsageList,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartStandardCpuUsage.setOption(this.standardCpuUsageOption);
    },
    // 内存使用率
    standardMemoryUsageLine: function () {
      this.chartStandardMemoryUsage = this.$echarts.init(
        this.$refs.standardMemoryUsage[0]
      );
      this.standardMemoryUsageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.StandardMemoryUsage")],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.StandardMemoryUsage"),
            type: "line",
            data: this.standardMemoryUsageList,
            itemStyle: {
              normal: {
                color: "#0072E3",
                lineStyle: {
                  color: "#0072E3",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartStandardMemoryUsage.setOption(this.standardMemoryUsageOption);
    },
    // 连接数使用率
    standardConnectionUsageLine: function () {
      this.chartStandardConnectionUsage = this.$echarts.init(
        this.$refs.standardConnectionUsage[0]
      );
      this.standardConnectionUsageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.StandardConnectionUsage")],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.StandardConnectionUsage"),
            type: "line",
            data: this.standardConnectionUsageList,
            itemStyle: {
              normal: {
                color: "#AAAAFF",
                lineStyle: {
                  color: "#AAAAFF",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartStandardConnectionUsage.setOption(
        this.standardConnectionUsageOption
      );
    },
    // QPS使用率
    standardQPSUsageLine: function () {
      this.chartStandardQPSUsage = this.$echarts.init(
        this.$refs.standardQPSUsage[0]
      );
      this.standardQPSUsageOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.StandardQPSUsage")],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.StandardQPSUsage"),
            type: "line",
            data: this.standardQPSUsageList,
            itemStyle: {
              normal: {
                color: "#C48888",
                lineStyle: {
                  color: "#C48888",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartStandardQPSUsage.setOption(this.standardQPSUsageOption);
    },

    //流入流出宽带使用率
    standardIntranetRatioLine: function () {
      this.chartStandardIntranetRatio = this.$echarts.init(
        this.$refs.standardIntranetRatio[0]
      );
      this.standardIntranetRatioOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 网络输入 网络输出
        legend: {
          x: "right",
          y: "10px",
          data: [
            this.$t("alarms.instance.line.StandardIntranetInRatio"),
            this.$t("alarms.instance.line.StandardIntranetOutRatio"),
          ],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.StandardIntranetInRatio"),
            type: "line",
            data: this.standardIntranetInRatioList,
            itemStyle: {
              normal: {
                color: "#00CACA",
                lineStyle: {
                  color: "#00CACA",
                },
              },
            },
          },
          {
            name: this.$t("alarms.instance.line.StandardIntranetOutRatio"),
            type: "line",
            data: this.standardIntranetOutRatioList,
            itemStyle: {
              normal: {
                color: "#02DF82",
                lineStyle: {
                  color: "#02DF82",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartStandardIntranetRatio.setOption(
        this.standardIntranetRatioOption
      );
    },
    /****************    Instance GCP折线图************/
    //缓存命中率
    cacheHitRatioLine: function () {
      this.chartCacheHitRatio = this.$echarts.init(this.$refs.cacheHitRatio[0]);
      this.cacheHitRatioOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.CacheHitRatio")],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.CacheHitRatio"),
            type: "line",
            data: this.cacheHitRatioList,
            itemStyle: {
              normal: {
                color: "#C48888",
                lineStyle: {
                  color: "#C48888",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartCacheHitRatio.setOption(this.cacheHitRatioOption);
    },

    //CPU使用率
    redisCpuUtilizationLine: function () {
      this.chartRedisCpuUtilization = this.$echarts.init(
        this.$refs.redisCpuUtilization[0]
      );
      this.redisCpuUtilizationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.RedisCpuUtilization")],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.RedisCpuUtilization"),
            type: "line",
            data: this.redisCpuUtilizationList,
            itemStyle: {
              normal: {
                color: "#C48888",
                lineStyle: {
                  color: "#C48888",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartRedisCpuUtilization.setOption(this.redisCpuUtilizationOption);
    },

    //未命中次数
    keyspaceMissesLine: function () {
      this.chartKeyspaceMisses = this.$echarts.init(
        this.$refs.keyspaceMisses[0]
      );
      this.keyspaceMissesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.KeyspaceMisses")],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.KeyspaceMisses"),
            type: "line",
            data: this.keyspaceMissesList,
            itemStyle: {
              normal: {
                color: "#C48888",
                lineStyle: {
                  color: "#C48888",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartKeyspaceMisses.setOption(this.keyspaceMissesOption);
    },

    //系统内存使用率
    systemMemoryUsageRatioLine: function () {
      this.chartSystemMemoryUsageRatio = this.$echarts.init(
        this.$refs.systemMemoryUsageRatio[0]
      );
      this.systemMemoryUsageRatioOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.SystemMemoryUsageRatio")],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.SystemMemoryUsageRatio"),
            type: "line",
            data: this.systemMemoryUsageRatioList,
            itemStyle: {
              normal: {
                color: "#C48888",
                lineStyle: {
                  color: "#C48888",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartSystemMemoryUsageRatio.setOption(
        this.systemMemoryUsageRatioOption
      );
    },

    //内存使用率
    usageRatioLine: function () {
      this.chartUsageRatio = this.$echarts.init(this.$refs.usageRatio[0]);
      this.usageRatioOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.UsageRatio")],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.UsageRatio"),
            type: "line",
            data: this.usageRatioList,
            itemStyle: {
              normal: {
                color: "#C48888",
                lineStyle: {
                  color: "#C48888",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartUsageRatio.setOption(this.usageRatioOption);
    },

    //收到的总连接数
    connectionsTotalLine: function () {
      this.chartConnectionsTotal = this.$echarts.init(
        this.$refs.connectionsTotal[0]
      );
      this.connectionsTotalOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.instance.line.ConnectionsTotal")],
        },
        series: [
          {
            name: this.$t("alarms.instance.line.ConnectionsTotal"),
            type: "line",
            data: this.connectionsTotalList,
            itemStyle: {
              normal: {
                color: "#C48888",
                lineStyle: {
                  color: "#C48888",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartConnectionsTotal.setOption(this.connectionsTotalOption);
    },
    /********************************/

    // 点击返回详情页
    ipAddress: function () {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.region = this.$route.query.region;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.cacheClusterId = this.$route.query.cacheClusterId;
      this.$router.push({
        path: "/elasticache/redisDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          cacheClusterId: this.cacheClusterId,
        },
      });
    },
  },
};
</script>

<style scoped>
.redis-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-col-span-6 {
  margin-bottom: 20px;
}
.redis-top {
  width: 100%;
  height: 53px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/elasticache/redis/redis_dashboard/Redis.vue